module.exports = __webpack_public_path__ + "img/Side slit length.c51b0a4d.png";